// Utilities
import Strings from "utils/strings"
import { notification } from "antd"
import {
	setLoader,
	setOrders,
	setTemporaryOrders,
	setOrdersToAggregate,
	setOrderGlobalInfo,
} from "store/actions"
import moment from "moment"
import { API, Endpoints } from "utils/api"
import {
	getStatusLabel as getStatusLabelUtil,
	getStatusColor,
} from "utils/status"

// All order attribute filters travel together in a single object to minimize
// the props/params passed around and the fields sent to the API.
export type OrderFilters = {
	bag?: string | null
	phone?: string | null
	payment?: string | null
	deliveryMode?: string | null
	geoZoneId?: string | null
}

// Get orders function to be called by this component
export async function getOrders(
	dispatch: any,
	selectedStatus: string[] | undefined,
	search: string | undefined | null,
	selectedBusiness: any,
	selectedContract: any,
	selectedDate: any,
	lot: string | undefined | null,
	pagination: { page: number; pageSize: number; total: number },
	setPagination: (fn: (prev: any) => any) => void,
	setDefaultLots: (lots: any[]) => void,
	filters?: OrderFilters
) {
	return fetchOrders(
		dispatch,
		selectedStatus,
		search,
		selectedBusiness,
		selectedContract,
		selectedDate,
		lot,
		pagination,
		setPagination,
		filters
	)
}

async function fetchOrders(
	dispatch: any,
	selectedStatus: string[] | undefined,
	search: string | undefined | null,
	selectedBusiness: any,
	selectedContract: any,
	selectedDate: any,
	lot: string | undefined | null,
	pagination: { page: number; pageSize: number; total: number },
	setPagination: (fn: (prev: any) => any) => void,
	filters?: OrderFilters
) {
	if (
		!selectedStatus ||
		selectedStatus.length === 0 ||
		!selectedBusiness ||
		!selectedContract ||
		!selectedDate
	) {
		dispatch(setOrders([]))
		setPagination((prev: any) => ({
			...prev,
			total: 0,
		}))
		return
	}

	dispatch(setLoader(true))

	const body: any = {
		page: pagination.page || 0,
		pageSize: pagination.pageSize || 1000,
		search: search || null,
		status: selectedStatus,
		businessId: selectedBusiness,
		contractId: selectedContract,
		date: moment.utc(selectedDate).format("YYYY-MM-DD"),
		filters: {
			bag: filters?.bag || null,
			phone: filters?.phone || null,
			payment: filters?.payment || null,
			deliveryMode: filters?.deliveryMode || null,
			geoZoneId: filters?.geoZoneId || null,
		},
		getTemporaryOrders: "true",
	}

	try {
		const response = await API.post({
			url: Endpoints.v2.uriOrders("search"),
			data: body,
		})

		if (response.ok) {
			const {
				orders,
				temporaryOrders,
				total,
				totalAggregation,
				totalErrors,
				totalWarnings,
			} = response.data.results || {}
			dispatch(setOrders(orders))
			dispatch(setTemporaryOrders(temporaryOrders || []))
			dispatch(
				setOrderGlobalInfo({
					totalAggregation: totalAggregation || 0,
					totalErrors: totalErrors || 0,
					totalWarnings: totalWarnings || 0,
				})
			)
			setPagination((prev: any) => ({
				...prev,
				total: total || orders.length,
			}))
		} else {
			notification.error({
				message: Strings.sidebar.orders,
				description: response?.data?.message || Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5,
			})
		}
	} catch (err) {
		console.error("getOrders error:", err)
		notification.error({
			message: Strings.serverErrors.title,
			description: Strings.serverErrors.wentWrong,
			placement: "bottomRight",
			duration: 5,
		})
	}

	dispatch(setLoader(false))
}

// async function getNormalOrders(
// 	dispatch: any,
// 	activeTab: string | undefined,
// 	search: string | undefined | null,
// 	selectedBusiness: any,
// 	selectedContract: any,
// 	selectedDate: any,
// 	pagination: { page: number; pageSize: number; total: number },
// 	setPagination: (fn: (prev: any) => any) => void
// ) {
// 	const body: any = {
// 		page: pagination.page || 0,
// 		pageSize: pagination.pageSize || 1000,
// 		search: search || null,
// 		status: activeTab,
// 		business: selectedBusiness,
// 		contract: selectedContract,
// 		date: moment.utc(selectedDate).format("YYYY-MM-DD"),
// 		getTemporaryOrders: activeTab === "address_confirmation" ? true : false,
// 	}

// 	try {
// 		const response = await API.post({
// 			url: Endpoints.uriOrders("search"),
// 			data: body,
// 		})

// 		if (response.ok) {
// 			const { orders, temporaryOrders, total } = response.data.results || {}
// 			dispatch(setOrders(orders))
// 			dispatch(setTemporaryOrders(temporaryOrders || []))
// 			setPagination((prev: any) => ({
// 				...prev,
// 				total: total || orders.length,
// 			}))
// 		} else {
// 			notification.error({
// 				message: Strings.sidebar.orders,
// 				description: response?.data?.message || Strings.serverErrors.wentWrong,
// 				placement: "bottomRight",
// 				duration: 5,
// 			})
// 		}
// 	} catch (err) {
// 		console.error("getOrders error:", err)
// 		notification.error({
// 			message: Strings.serverErrors.title,
// 			description: Strings.serverErrors.wentWrong,
// 			placement: "bottomRight",
// 			duration: 5,
// 		})
// 	}
// }

// async function getAggregationOrders(
// 	dispatch: any,
// 	selectedBusiness: any,
// 	selectedContract: any,
// 	lot: string | undefined | null
// ) {
// 	try {
// 		const response = await API.post({
// 			url: Endpoints.uriOrdersToAggregate(),
// 			data: {
// 				business: selectedBusiness,
// 				contract: selectedContract,
// 				lot: lot?.toString() || null,
// 			},
// 		})

// 		if (response.ok) {
// 			const { orders, ordersToAggregate } = response.data.results || {}
// 			let auxId = 1
// 			for (const obj of ordersToAggregate || []) {
// 				obj.boxName = Strings.orders.box + " " + auxId
// 				if (obj.temporary && !obj.registeredId) obj.boxId = ""
// 				for (const bag of obj.bags || []) {
// 					bag.boxOrderId = obj._id
// 				}
// 				auxId++
// 			}
// 			dispatch(setOrders(orders || []))
// 			dispatch(setOrdersToAggregate(ordersToAggregate || []))
// 		} else {
// 			console.error("API response not ok:", response)
// 			notification.error({
// 				message: Strings.sidebar.orders,
// 				description: response?.data?.message || Strings.serverErrors.wentWrong,
// 				placement: "bottomRight",
// 				duration: 5,
// 			})
// 		}
// 	} catch (err) {
// 		console.error("getAggregationOrders error:", err)
// 		notification.error({
// 			message: Strings.serverErrors.title,
// 			description: Strings.serverErrors.wentWrong,
// 			placement: "bottomRight",
// 			duration: 5,
// 		})
// 	}
// }

// Re-export the unified status utilities for backward compatibility
export { getStatusColor }
export const getStatusLabel = getStatusLabelUtil

// Get default lots for the selected business, contract and date
export async function getDefaultLots(
	business: string | null,
	contract: string | null,
	date: string | null
): Promise<any[]> {
	if (!business || !contract || !date) return []
	try {
		const formattedDate = moment.utc(date).format("YYYY-MM-DD")
		const response = await API.get({
			url: Endpoints.uriOrders("uniqueLots"),
			params: {
				business,
				contract,
				date: formattedDate,
			},
		})
		if (response.ok) {
			return response.data.results || []
		}
	} catch (err) {
		console.error("getDefaultLots error:", err)
	}
	return []
}
